<template>
    <confirmation-page-layout :company="company" :loaded="loaded" :tourlead="tourlead">
        <template v-slot:breadcrumbs>
            <car-breadcrumbs :search-request="searchRequest" :product="product" />
        </template>
        <template v-slot:sidebar>
            <cars-search-summary :search-request="searchRequest" search-disabled />
            <car-order-summary
                :search-request="searchRequest"
                :info="product.info"
                :offer="product.offer"
                :prepare-book-response="prepareBookResponse"
            />
        </template>
    </confirmation-page-layout>
</template>

<script lang="ts">
    import {Component, mixins} from 'vue-facing-decorator'
    import ConfirmationPageLayout from '@/components/parts/ConfirmationPageLayout.vue'
    import CarBreadcrumbs from '@/components/carsRent/CarBreadcrumbs.vue'
    import {ConfirmationPageMixin} from '@/mixins/ConfirmationPageMixin.vue'
    import {CarsSearchPageMixin} from '@/components/carsRent/mixins/CarsSearchPageMixin.vue'
    import CarsSearchSummary from '@/components/carsRent/search/CarsSearchSummary.vue'
    import CarOrderSummary from '@/components/carsRent/booking/CarOrderSummary.vue'

    @Component({
        components: {
            ConfirmationPageLayout,
            CarBreadcrumbs,
            CarsSearchPageMixin,
            CarsSearchSummary,
            CarOrderSummary,
        },
        async setup() {
            return await useConfirmationPage()
        },
    })
    export class CarConfirmationPage extends mixins(ConfirmationPageMixin, CarsSearchPageMixin) {
        get basketItem() {
            return carsRentStore.basketItem(carsRentStore.prepareBookRequest.offerKey)
        }

        get product() {
            return this.basketItem.product
        }

        get offer() {
            return this.product.offer
        }

        get searchRequest() {
            return this.basketItem.searchRequest
        }
    }

    export default CarConfirmationPage
</script>
